import React, { Component } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import R from 'common/res/R';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  title: {
    ...R.typography.weightBold,
    color: R.color.uiLightPrimary,
    fontSize: R.typography.fontSize.medium,
  },
  subtitle: {
    color: R.color.uiLightPrimary,
    fontSize: R.typography.fontSize.tiny,
  },
});

class HeaderTwoLine extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
  };

  render() {
    const { title, subtitle } = this.props;

    return (
      <View style={styles.container}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.subtitle}>{subtitle}</Text>
      </View>
    );
  }
}

export default HeaderTwoLine;
